// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cus-date-input {
  position: absolute;
  inset: 0;
  appearance: none;
  opacity: 0;
}

.cus-date-input::-webkit-calendar-picker-indicator {
  position: absolute;
  background-color: aqua;
  z-index: 1;
  inset: 0;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/corpaction/corpActionMaster/date/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;AACd","sourcesContent":[".cus-date-input {\n  position: absolute;\n  inset: 0;\n  appearance: none;\n  opacity: 0;\n}\n\n.cus-date-input::-webkit-calendar-picker-indicator {\n  position: absolute;\n  background-color: aqua;\n  z-index: 1;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
